<template>
    <hm-content title="">
      <div>
        <el-button type="primary" size="small" @click="addDialog"
        >新增支付</el-button
        >
      </div>
        <div class="table-panel flex flex-end">
            <div>
              <el-input
                  clearable
                  class="mr10"
                  size="small"
                  v-model.trim="searchCondition.merchantNo"
                  placeholder="请输入商户号"
              ></el-input>
              <el-input
                  clearable
                  class="mr10"
                  size="small"
                  v-model.trim="searchCondition.terminalId"
                  placeholder="请输入终端号"
              ></el-input>
              <el-select
                  clearable
                  v-model="searchCondition.shopId"
                  placeholder="搜索/选择门店"
                  size="small"
                  filterable
                  class="mr10 flex-1"
              >
                <el-option
                    :label="v.shopName"
                    :value="v.shopId"
                    v-for="(v, i) in shopList.records"
                    :key="i"
                ></el-option>
              </el-select>
              <el-button type="primary" size="small" @click="search">查询</el-button>

            </div>

        </div>
        <div  class="inputDeep">
            <el-table
                    :data="tableData"
                    stripe
                    style="width: 100%"
            >
                <el-table-column
                        header-align="center"
                        align="center"
                        type="index"
                        label="序号"
                        width="50"
                        :index="index => index + (currentPage - 1) * pageSize + 1"
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="merchantNo"
                        label="商户号"
                        >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="终端号"
                        prop="terminalId">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="shopName"
                        label="支付门店">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="支付类型"
                        prop="paySource">
                  <template slot-scope="scope">
                    <span v-if="scope.row.paySource == 'xcx'">小程序</span>
                    <span v-if="scope.row.paySource == 'Overseas'">跨境购</span>
                    <span v-if="scope.row.paySource == 'thirdOverseas'">三方选品</span>
                    <span v-if="scope.row.paySource == 'alipay'">支付宝</span>
                    <span v-if="scope.row.paySource == 'smg'">扫码购</span>
                  </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="createTime"
                        label="创建时间">
                </el-table-column>

                <el-table-column
                        header-align="center"
                        align="center"
                        prop="id"
                        label="操作">
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-tooltip class="item" content="编辑" placement="top">
                        <div class="pointer mr10" @click="editDialog(scope.row)">
                          <span class="hmicon icon-bianji blue"></span>
                        </div>
                      </el-tooltip>
                      <el-tooltip class="item" content="删除" placement="top">
                        <div class="pointer mr10" @click="remove(scope.row)">
                          <span class="hmicon icon-shanchu primary"></span>
                        </div>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
            </el-table>
        </div>
      <el-dialog
          :title="mode === 'add' ? '新增' : '编辑'"
          :close-on-click-modal="false"
          :visible.sync="dialogFormVisible"
          width="800px"
          @close="resetForm('ruleForm')"
      >
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="large-label-form"
        >
            <el-form-item label="商户号：" prop="merchantNo">
                <el-input
                    size="small"
                    clearable
                    v-model.trim="ruleForm.merchantNo"
                ></el-input>
            </el-form-item>
            <el-form-item label="终端号：" prop="terminalId">
                <el-input
                    size="small"
                    clearable
                    v-model.trim="ruleForm.terminalId"
                ></el-input>
            </el-form-item>
            <el-form-item label="支付门店：" prop="shopId">
                <el-select
                    filterable
                    clearable
                    v-model="ruleForm.shopId"
                    value-key="shopId"
                    placeholder="请选择支付门店"
                    size="small"
                >
                  <el-option
                      v-for="item in shopList.records"
                      :key="item.shopName"
                      :label="item.shopName"
                      :value="item.shopId"
                  >
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付类型：" prop="paySource">
                <el-select
                    clearable
                    v-model="ruleForm.paySource"
                    placeholder="选择支付类型"
                    size="small"
                    filterable
                    class="mr10 flex-1"
                >
                  <el-option
                      v-for="item in payTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付秘钥：" prop="accessToken">
              <el-input
                  size="small"
                  style="width: 300px"
                  clearable
                  v-model.trim="ruleForm.accessToken"
              ></el-input>
            </el-form-item>
        </el-form>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="save">确 定</el-button>
          <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
        <div class="hm-pagination">
            <el-pagination
                    background
                    :total="total"
                    @current-change="paging"
                    @size-change="handleSizeChange"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="currentPage"
            ></el-pagination>
      </div>
    </hm-content>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "storeFinanceDayStatInfo",
    data() {
        return {
            total: 0,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                    }
                },
            searchCondition: {
                shopId: '',
            },
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            dialogFormVisible: false,
            ruleForm: {
              merchantNo: "",
              terminalId: "",
              shopId: "",
              accessToken: "",
              paySource: "",
              id: "",
            },
            rules: {
                merchantNo: [{
                  required: true,
                  trigger: "blur",
                  message: "请输入商户号"
                }],
                terminalId: [{
                  required: true,
                  trigger: "blur",
                  message: "请输入终端号"
                }],
                accessToken: [{
                  required: true,
                  trigger: "blur",
                  message: "请输入支付秘钥"
                }]
            },
            payTypes: [{
              value: 'xcx',
              label: '小程序'
            }, {
              value: 'Overseas',
              label: '跨境购'
            }, {
              value: 'alipay',
              label: '支付宝'
            }, {
              value: 'smg',
              label: '扫码购'
            }, {
              value: 'thirdOverseas',
              label: '三方选品'
            }],
            mode: "add",
        }
    },
    computed: mapGetters([
      "shopList",
    ]),
    created() {
        this.queryList();
        this.queryShopList();
    },
    methods: {
        paging(page) {
            this.currentPage = page;
            this.queryList();
        },
        handleSizeChange(size) {
            this.currentPage = 1;
            this.pageSize = size;
            this.queryList();
        },
        search() {
            this.currentPage = 1;
            this.queryList();
        },
        isArray(arr) {
            return Object.prototype.toString.call(arr) === "[object Array]";
        },
        async queryList() {
            const params = {
              pageSize: this.pageSize,
              pageNo: this.currentPage
            };
            const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
            Object.assign(params, searchCondition);
            const { result } = await this.$store.dispatch(
                "saoBeiList",
                params
            );
            const { records, total } = result;
            this.tableData = records;
            this.total = total;
        },
        queryShopList() {
          this.$store.dispatch("queryShopList", {
                pageNo: 1,
                pageSize: 10
            });
        },
        editDialog(row) {
            this.mode = "edit";
            this.currentRow = row;
            this.ruleForm.id = row.id;
            this.dialogFormVisible = true;
            for (let key in row) {
                if (this.ruleForm.hasOwnProperty(key)) {
                    this.ruleForm[key] = row[key];
                }
            }
        },
        async remove(row) {
          const params = {
            id: row.id
          };
          this.$confirm(" 是否确认删除?", "提示", {
            cancelButtonText: "取消",
            confirmButtonText: "确定",
            type: "warning"
          }).then(() => {
            row.operationType = "del";
            this.$store.dispatch("saoBeiDelete", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryList();
              }
            });
          });
        },
        update() {
            console.log(this.ruleForm);
        },
        addDialog() {
            this.mode = "add";
            this.dialogFormVisible = true;
        },
        save() {
          const params = JSON.parse(JSON.stringify(this.ruleForm));
          this.$refs.ruleForm.validate(valid => {
            if (valid) {
              this.$store.dispatch(
                      this.mode === "add" ? "saoBeiAdd" : "saoBeiEdit",
                      params
                  ).then(res => {
                    if (res.code === "0") {
                      this.$message({
                        message: "操作成功",
                        type: "success"
                      });
                      this.dialogFormVisible = false;
                      this.queryList();
                      setTimeout(() => {
                        this.resetRuleForm();
                      }, 0);
                    }
                  });
            }
          });

        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            for (let key in this[formName]) {
                this[formName][key] = "";
            }
            this.dialogFormVisible = false;
        },
    }
}
</script>

<style scoped>
.inputDeep>>>.el-input__inner{
    border: 0;
    background: none;
}
</style>
